import script from "./ContractsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractsTable.vue?vue&type=script&setup=true&lang=js"

import "./ContractsTable.vue?vue&type=style&index=0&id=c2a84a7c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2a84a7c"]])

export default __exports__